import React, { useState, useEffect, useLayoutEffect } from "react";
import { Wrapper } from "./LeadForm.styled";
import LeadSubmission from "components/pageSection/LeadForm/LeadSubmission/LeadSubmission";
import SelectLocation from "components/pageSection/LeadForm/SelectLocation/SelectLocation";
import AdditionalInformation from "components/pageSection/LeadForm/AdditionalInformation/AdditionalInformation";
import Final from "components/pageSection/LeadForm/final/Final";
import { Steps } from "components/common";
import { callGetApi } from "utils/api";
import LeadFormSm from "views/LeadFormSm/LeadFormSm";
import { FaAirbnb } from "react-icons/fa";
import LeadFormSteps from "views/LeadFormSteps/LeadFormSteps";

const { Step } = Steps;

const LeadForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const stepsArray = ['hm', 'lo', 'ad', 'ap'];
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    utilPic: null,
    appointmentTime: "",
    dateCreated: Date().toString(),
    averageMonthlyBill: "",
    yearlyUsage: "",
    company_id: 9146,
    forceSend: "",
    utility_company: "",
    utility_id: "",
    lat: "",
    lng: "",
    jan: "",
    feb: "",
    mar: "",
    apr: "",
    may: "",
    jun: "",
    jul: "",
    aug: "",
    sep: "",
    oct: "",
    nov: "",
    dec: "",
  });
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    initailFormApi();
  }, []);
  const initailFormApi = () => {
    callGetApi("/leads/form/calender/event", onSuccessForm, onFailForm);
  };

  const onSuccessForm = (data) => {
  };
  const onFailForm = (err) => {
    console.log(err);
  };
  const next = () => {
    setCurrentStep(currentStep + 1);
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 900) {
        setIsSmallScreen(true);
      } else {
        return setIsSmallScreen(false);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <>
      {isSmallScreen ? (
        <LeadFormSm />
      ) : (
        <Wrapper>
          <div className="steps-container">
            {/* <Steps labelPlacement={"vertical"} current={currentStep}>
              <Step title="HOME OWNER" description={<FaAirbnb size={25} fill="white" />} />
              <Step title="SELECT LOCATION" />
              <Step title="ADDITIONAL INFORMATION" />
              <Step title="FINAL" />
            </Steps > */}
            <LeadFormSteps label={stepsArray[currentStep]} />
          </div >
          <div className="submission-container">
            {currentStep === 0 && (
              <LeadSubmission
                next={next}
                setFormData={setFormData}
                formData={formData}
              />
            )}
            {currentStep === 1 && (
              <SelectLocation
                next={next}
                prev={prev}
                setFormData={setFormData}
                formData={formData}
              />
            )}
            {currentStep == 2 && (
              <AdditionalInformation
                setFormData={setFormData}
                formData={formData}
                next={next}
                prev={prev}
              />
            )}
            {currentStep == 3 && (
              <Final prev={prev} setFormData={setFormData} formData={formData} />
            )}
          </div>
        </Wrapper >
      )}
    </>
  );
};

export default LeadForm;
